import { toast } from "react-toastify";

const copyContactToClipboard = (
  item,
  personalData,
  contactData,
  socialData,
  contactEntities,
  asesors
) => {
  // Información del contacto (puedes obtenerla de un objeto dinámico)
  const contact = {
    nombres: item?.first_name,
    apellidos: item?.last_name,
    cargo: item?.charge?.name,
    jurisdiccion: personalData?.jurisdiccion?.name,
    "espacio politico": personalData?.politic_space?.name,
    distrito: personalData?.district?.name,
    bloque: personalData?.block?.name,
    "fecha inicio de mandato": personalData?.charge_start_at,
    "fecha fin de mandato": personalData?.charge_end_at,
    "url de perfil": personalData?.profile_url,
    "email 1": contactData?.email_1,
    "whatsapp 1 ": contactData?.whatsapp_1,
    "email 2": contactData?.email_2,
    "whatsapp 2": contactData?.whatsapp_2,
    "email 3": contactData?.email_3,
    "whatsapp 3 ": contactData?.whatsapp_3,
    facebook: socialData?.facebook_url,
    "sitio web": socialData?.website_url,
    instagaram: socialData?.instagaram_url,
    "instagram username": socialData?.instagaram_username,
    twitter: socialData?.twitter_url,
    "twitter username": socialData?.twitter_username,
    "linkedin url": socialData?.linkedin_url,
    entidades: contactEntities.map((entity) => entity.name).join(", "),
    comisiones: item?.comissions
      .map((comission) => `${comission.name} - ${comission.district?.name}`)
      .join(", "),
    asesores: asesors
      .map(
        (asesor) =>
          `${asesor.first_name} ${asesor.last_name} - CARGO:  ${asesor?.charge?.name} - AREA: ${asesor?.area?.name} 
        - EMAIL: ${asesor?.email} - TELEFONO: ${asesor?.phone} -  WHATSAPP: ${asesor?.whatsapp} - 
        - LINKEDIN: ${asesor?.linkedin_url} - FACEBOOK: ${asesor?.facebook_url} - 
        - TWITTER: ${asesor?.twitter_url} - TWITTER USERNAME: ${asesor?.twitter_username} - 
        - INSTAGRAM: ${asesor?.instagram_url} - INSTAGRAM USERNAME: ${asesor?.instagram_username}`
      )
      .join(", "),
  };

  // Formatear la información del contacto
  // const formattedContact = Nombre: ${contact.name}\nTeléfono: ${contact.phone}\nEmail: ${contact.email};
  const formattedContact = Object.entries(contact)
    .filter(([key, value]) => value) // Filtrar propiedades con valores no nulos o no definidos
    .map(([key, value]) => `${key.toUpperCase()}: ${value}`) // Formatear cada línea
    .join("\n");

  // Copiar al portapapeles usando la API de Clipboard
  navigator.clipboard
    .writeText(formattedContact)
    .then(() => {
      toast.info(`¡La información del contacto se ha copiado al portapapeles!`);
    })
    .catch((err) => {
      console.error("Error al copiar al portapapeles: ", err);
    });
};

export default copyContactToClipboard;
